var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.79454 6.35739C6.79445 6.35734 6.79463 6.35744 6.79454 6.35739V6.35739ZM7.55815 5.0663C6.66834 4.5398 5.5459 5.18268 5.5459 6.21429V9.78507C5.5459 10.8167 6.66834 11.4596 7.55815 10.9331C7.55806 10.9331 7.55824 10.933 7.55815 10.9331L10.5771 9.14751C11.4499 8.63162 11.4503 7.36797 10.5775 6.85208L7.55815 5.0663ZM7.0459 6.50606L9.57127 7.99968L7.0459 9.4933V6.50606ZM6.79427 9.64213C6.79419 9.64218 6.79436 9.64208 6.79427 9.64213V9.64213Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33333 1.75C2.45877 1.75 1.75 2.45877 1.75 3.33333V12.6667C1.75 13.5412 2.45877 14.25 3.33333 14.25H12.6667C13.5412 14.25 14.25 13.5412 14.25 12.6667V3.33333C14.25 2.45877 13.5412 1.75 12.6667 1.75H3.33333ZM0.25 3.33333C0.25 1.63034 1.63034 0.25 3.33333 0.25H12.6667C14.3697 0.25 15.75 1.63034 15.75 3.33333V12.6667C15.75 14.3697 14.3697 15.75 12.6667 15.75H3.33333C1.63034 15.75 0.25 14.3697 0.25 12.6667V3.33333Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlay);
export default __webpack_public_path__ + "static/media/icon-play.0aeefddb8ae549481bd768e8843ff4ca.svg";
export { ForwardRef as ReactComponent };